var PD = PD || {};

/**
 * Ajax requests
 * @namespace
 */
PD.Ajax = (function (a) {
  // TODO: Request id
  // TODO: Cancel request
  // TODO: Prompt on page navigation if request is in progress
  // TODO: Perhaps make the request set the page loading?

  var _requests = {}; // format: {xhr: <jqXHR>, success: <Array>, error: <Array>, complete: <Array>}
  var _defaults = {
    error: function () { return undefined; },
    success: function () { return undefined; },
    complete: function () { return undefined; },
    stringifyData: false,
    mergeRequest: true
  };

  /**
   * Proxy for $.ajax
   * Keeps track of all requests in _requests, and merges duplicate requests if one is in-flight
   * NOTE: Turns cfg.data objects into strings by JSON.stringify
   * ```
   * $.ajax({data: {foo: "bar", 0: 1}})           => ?foo=bar&0=1
   * PD.Ajax.request({stringifyData: true, ...})  => ?{"foo":"bar","0":1}
   * ```
   * This is for compatibility with old code. Do not write new code without stringifyData: false
   * If this module won't be used in old code, the default should be changed to false
   *
   * Configuration options:
   * ```
   * {
   *   ...                  // every option for $.ajax can also be used here
   *   stringifyData: true, // whether to stringify data rather than using as GET params
   *   mergeRequest: true,  // if true, and an existing request to the URL is in-flight (with same data), merge into existing request
   * }
   * ```
   * @function
   * @name PD.Ajax#request
   * @param  {Object} cfg  The configuration object. cfg.url is required.
   */
  
  a.request = function(cfg) {
    var success, error, complete;

    if (cfg.data instanceof FormData) {
      cfg.mergeRequest = cfg.mergeRequest || false;
    }
     
    cfg = $.extend({},_defaults,cfg);
    if (!cfg.url) {
      throw new Error("PD.Ajax.request(): No url given");
    }
    
    // ID should be identical for identical requests
    var id = cfg.url+"---"+JSON.stringify(cfg.data)+"---"+cfg.stringifyData;

    success = $.proxy(cfg.success,this);
    error = $.proxy(cfg.error,this);
    complete = $.proxy(cfg.complete,this);

    if (_requests.hasOwnProperty(id) && cfg.mergeRequest) {
      // if we have a matching in-flight request, use that instead
      _requests[id].success.push(success);
      _requests[id].error.push(error);
      _requests[id].complete.push(complete);
    } else {
      // otherwise, fire off a new request
      var obj = {
        success: [success],
        error: [error],
        complete: [complete]
      };
      _requests[id] = obj;

      // make success callback call every registered callback
      cfg.success = $.proxy(function(data, textStatus, jqXHR) {
        for (var i = 0; i < obj.success.length; ++i) {
          obj.success[i](data, textStatus, jqXHR);
        }
      }, this);

      // make error callback call every registered callback
      cfg.error = $.proxy(function(jqXHR, textStatus,errorThrown) {
        for (var i = 0; i < obj.error.length; ++i) {
          obj.error[i](jqXHR, textStatus, errorThrown);
        }
      },this);

      // and finally make complete callback call every registered callback
      cfg.complete = $.proxy(function(jqXHR, textStatus) {
        for (var i = 0; i < obj.complete.length; ++i) {
          obj.complete[i](jqXHR, textStatus);
        }
        // also delete the object once we're done
        delete _requests[id];
      }, this);

      if (typeof cfg.data === "object" && cfg.stringifyData) {
        cfg.processData = false;
        cfg.data = JSON.stringify(cfg.data);
      }

      obj.xhr = $.ajax(cfg);
    }
  };

  return a;
}(PD.Ajax || {}));
//------------------------------------------------------------------------------
